export const CALLS_STAGES = {
  HISTORY: 'history',
  EXTRACT: 'extract',
}
